import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import styles from './signUp.styles';
import PanelWithImage from './PanelWithImage';
import logo from '../images/logo.png';
import SignUpWithoutDevice from './SignUpWithoutDevice';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles()(styles);

function CompanionSignUp(props) {
  const { classes } = useStyles();
  const history = useNavigate();

  const handleGoBack = (e) => {
    e.preventDefault();
    history('/sign-up');
  };

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <PanelWithImage />
      <Grid item className={classes.rightPanelContainer} xs={12} md={6}>
        <div className={classes.rightPanel}>
          <div className={classes.rightPanel}>
            <div className={classes.header}>
              <div>
                <img className={classes.logo} src={logo} alt="CAN logo" />
              </div>
            </div>
            <div>
              <SignUpWithoutDevice handleGoBack={handleGoBack} props={props} />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default CompanionSignUp;
